// extracted by mini-css-extract-plugin
export default {"addToBook":"AddBookmark_addToBook__twLf+","booked":"AddBookmark_booked__vPdEk"};